import React from 'react'
import { Button, Callout, FormGroup, InputGroup, Intent, Checkbox, Icon, Popover, PopoverPosition, Label, Switch, AnchorButton } from '@blueprintjs/core'
import cx from 'classnames'
import { lang, toast } from 'enablex/shared'
import style from './style.scss'
import UserIcon from '~/icons/UserIcon'
import SettingsIcon from '~/icons/SettingsIcon'
import ChatIcon from '~/icons/ChatIcon'
import VerticalEllipses from '~/icons/VerticalEllipses'
import AnalyticsIcon from '~/icons/AnalyticsIcon'

export const BotCard = ({config}) => {
    return <>
        <div
            className={cx('bp_table-row', style.tableRow)}
        >
            {/* Title */}
            <div className={style.title}>
                <div className={style.titleLeft}>
                    <div className={style.titleAndBadges}>

                        <a href={'javascript:void(0)'} style={{ pointerEvents: 'none', color: config?.themeColor }}>
                            Bot
                        </a>

                    </div>
                    <span style={{ fontSize: '14px', marginTop: '5px' }}>
                        Webchat
                    </span>
                    <span style={{ fontSize: '12px', marginTop: '5px', fontWeight: 'normal' }}>
                        <span>
                            {' '}
                            <strong> Created: </strong>{' '}
                        </span>
                    </span>

                </div>

                {/* Publish Switch */}
                <Switch
                    checked={true}
                    innerLabelChecked="Published"
                    innerLabel="Drafted"
                    className={cx('bot-status-switch', style.botStatusSwitch)}
                    large={true}
                />
            </div>
            {/* End Title */}

            {/* Divider */}
            <div className={cx('actions-divider', style.actionsDivider)}></div>
            {/* End Divider */}

            {/* Actions */}
            <div className={cx('actions', style.actions)}>
                <div className={'actions-left'}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#1d6c90'
                        }}
                    >
                        <AnchorButton
                            icon={<UserIcon color={'#333'} strokeWidth={'2'} />}
                            minimal
                            text={'Agents (0)'}
                        />
                    </div>
                </div>
                <div className={'actions-right'} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <AnchorButton
                        text={lang.tr('admin.workspace.bots.item.config')}
                        icon={<SettingsIcon />}
                        minimal
                    />

                    {/* <AnchorButton
                        text={lang.tr('admin.workspace.bots.item.openChat')}
                        icon={<ChatIcon />}
                        target="_blank"
                        minimal
                    /> */}

                    <AnchorButton
                        id="btn-menu-analytics"
                        key="analytics"
                        text={lang.tr('module.analytics.fullName') || 'Analytics'}
                        icon={<AnalyticsIcon />}
                        minimal
                    />

                    <AnchorButton
                        className="btn-menu-bot-item"
                        icon={<VerticalEllipses />}
                        minimal
                    />
                </div>
            </div>
            {/* End Actions */}
        </div>
    </>
}
